export const initialTheme = 'dark-theme';
